import React, { useState, useEffect, Fragment } from "react";

import cardStyles from "assets/jss/material-dashboard-pro-react/components/cardStyle.js";

import { useDispatch, useSelector } from "react-redux";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "../../../../../assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styles1 from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";

import { Tabs } from "antd";
import "antd/dist/antd.css";

import { useTranslation } from "react-i18next";

import useTable from "../../../../Components/useTable";

import GridContainer from "components/Grid/GridContainer.js";
// core components
import GridItem from "components/Grid/GridItem.js";

import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import AddProjectModal from "./AddProjectModal";

import ErrorModal from "../../../../Components/ErrorModal";
import {
  CloseOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { unwrapResult } from "@reduxjs/toolkit";
import {
  addNewProject,
  fetchProjectsByPersonId,
  deleteProject,
} from "../../../../../reduxToolkit/features/Project/projectSlice.js";
const useStyles3 = makeStyles(styles1);
const { TabPane } = Tabs;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "fit-content",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    "& svg": {
      margin: theme.spacing(1.5),
    },
    "& hr": {
      margin: theme.spacing(0, 0.5),
    },
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));
const useStyles2 = makeStyles(styles);
const useCardStyles = makeStyles(cardStyles);

const headCells = [
  { id: "Title", label: "Title" },
  { id: "type_of_project", label: "Type Of Project" },
  { id: "team Members", label: "Team Members" },
  { id: "StartDate", label: "Start Date" },
  { id: "EndDate", label: "End Date" },
  { id: "UntilNow", label: "Until Now" },
  { id: "Description", label: "Description" },
  { id: "delete", label: "" },
];

export default function ProjectList(props) {

  const { t } = useTranslation();
  const classes = useStyles();
  const classes1 = useStyles1();
  const classes2 = useStyles2();
  const classes3 = useStyles3();
  const dispatch = useDispatch();

  const [records, setRecords] = [];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTable(records, headCells, filterFn);
  let person_id = props.person && props.person.id;
  useEffect(() => {
    dispatch(fetchProjectsByPersonId(person_id));
  }, [dispatch]);

  const projects = useSelector((state) => state.Project.Projects);
  
  const DeleteProject = (id) => {
    dispatch(deleteProject(id))
      .then(unwrapResult)
      .then(() => {
        dispatch(fetchProjectsByPersonId(person_id));
      });
  };
  const [pageSize, setPageSize] = React.useState(10);
  return (
    <div>
      <GridContainer xs={12} sm={12} md={12}>
        <GridItem key={Element.id} xs={12} sm={12} md={11}></GridItem>
        <GridItem key={Element.id} xs={12} sm={12} md={1}>
          <AddProjectModal person_id={person_id} />
        </GridItem>
      </GridContainer>

      <TblContainer style={{ marginTop: "0px", paddingTop: "0px" }}>
        {projects && projects.length != 0 && <TblHead />}
        <TableBody>
          {projects &&
            projects.map((item) => (
              <TableRow key={item.id}>
                <TableCell
                  style={{
                    borderLeft: "1px solid lightgrey",
                    borderRight: "1px solid lightgrey",
                  }}
                >
                  <p
                    style={{
                      display: "-webkit-box",
                      maxWidth: "100px",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item && item.title}
                  </p>
                </TableCell>
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  <p
                    style={{
                      display: "-webkit-box",
                      maxWidth: "100px",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item && item.type_of_project && item.type_of_project}
                  </p>
                </TableCell>
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  <p
                    style={{
                      display: "-webkit-box",
                      maxWidth: "100px",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item && item.team_members}
                  </p>
                </TableCell>
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  {item && item.start_date}
                </TableCell>
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  {item && item.end_date}
                </TableCell>
            

                
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  {item && item.until_now ? (
                    <CheckOutlined style={{ color: "green" }} />
                  ) : (
                    <CloseOutlined style={{ color: "red" }} />
                  )}
                </TableCell>

                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  <p
                    style={{
                      display: "-webkit-box",
                      maxWidth: "100px",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item && item.description}
                  </p>
                </TableCell>

                <TableCell>
                  <DeleteOutlined
                    onClick={() => DeleteProject(item && item.id)}
                    style={{ color: "red" }}
                  />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </TblContainer>
    </div>
  );
}
